// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";

import actionCreators from "@modules/service/actionCreator";
import * as serviceSelectors from "@modules/service/selectors";
import { Button, SchemaForm, type StepProps } from "@components";
import type { WellbeingServiceContent } from "@modules/service/reducer/wellbeing-services/types";
import { uiSchema } from "./ui-schema";

type PropsFromState = $Exact<{
  draft: ?WellbeingServiceContent,
  mainDetailsSchema: Object | null,
}>;

type PropsFromDispatch = $Exact<{
  onUpdateDraft: typeof actionCreators.SetWellbeingServiceDraft,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class Step1MainDetails extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  get data() {
    return this.props.draft;
  }

  handleMainDetailsNext = () => {
    if (this.formRef) {
      this.formRef.current.submit();
    }
  };

  handleSubmittedMainDetailsForm = (formData: Object) => {
    if (formData) {
      const updatedDraft = { ...this.props.draft, ...formData };

      this.props.onUpdateDraft(updatedDraft);
      if (this.props.handleSubmit) {
        this.props.handleSubmit(updatedDraft, true);
      }
    }
  };

  handleChange = (formData: Object) => {
    this.props.onUpdateDraft({ ...this.data, ...formData });
  };

  render() {
    if (!this.props.editable) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="w-100 d-flex justify-content-center">
          <div className="col-sm-8">
            {this.data && this.props.mainDetailsSchema ? (
              <SchemaForm
                ref={this.formRef}
                className="w-100"
                formData={this.data || {}}
                schema={this.props.mainDetailsSchema || {}}
                uiSchema={uiSchema(this.props.t)}
                onChange={this.handleChange}
                onSubmit={this.handleSubmittedMainDetailsForm}
                externalSubmit
              >
                <div className="d-flex justify-content-center" />
              </SchemaForm>
            ) : null}
          </div>
        </div>
        <div className="w-100 d-flex justify-content-end mt-5 mb-3">
          <Button materialIcon="fast_forward" onClick={this.handleMainDetailsNext}>
            {this.props.t("NEXT")}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state): PropsFromState => {
  return {
    draft: serviceSelectors.getWellbeingServicesDraft(state),
    mainDetailsSchema: serviceSelectors.getWellbeingServiceMainDetailsSchema(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  onUpdateDraft: actionCreators.SetWellbeingServiceDraft,
};

export default compose(localize(), connect(mapStateToProps, mapDispatchToProps))(Step1MainDetails);
